var _path;
import * as React from "react";
function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.457 29.745a3.604 3.604 0 005.094 0l14.394-14.394a3.583 3.583 0 00.776-3.924A3.6 3.6 0 0034.393 9.2H5.605c-1.45 0-2.767.877-3.329 2.227a3.603 3.603 0 00.776 3.924l14.394 14.394h.011z"
  })));
}
export default SvgCaretDown;